export const typeOrder = ['COLOR', 'CUSTOM', 'SIZE'];
